import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const CopyrightRegistration = () => {
  const usps = [
    {
      title: 'Legal Copyright Protection',
      description: 'Secure official federal copyright protection for your creative works. Registration establishes a public record of your copyright claim and is required before filing infringement lawsuits.'
    },
    {
      title: 'Fast Processing',
      description: 'Our streamlined process ensures quick, accurate filing with the U.S. Copyright Office. We handle all documentation and follow-up to keep your registration moving forward efficiently.'
    },
    {
      title: 'Expert Guidance',
      description: 'Our copyright specialists guide you through the registration process, ensuring proper classification and complete documentation for maximum legal protection of your creative works.'
    },
    {
      title: 'Lifetime Protection',
      description: 'Copyright protection lasts for the life of the author plus 70 years, or 95 years for works made for hire. We help you establish permanent legal protection for your creative assets.'
    }
  ];

  const whyChooseContent = {
    about: 'Copyright registration provides essential legal protection for original works of authorship including literary, musical, artistic, and certain other intellectual works. Registration with the U.S. Copyright Office creates a public record of your copyright claim and is necessary before filing an infringement lawsuit.',
    intro: 'Protecting your creative works is essential in today\'s digital age. Trademark Vector makes copyright registration simple, affordable, and accessible.',
    paragraph1: 'From books and music to software and artwork, we handle copyright registrations for all types of creative works. Our experienced team ensures your application is complete, accurate, and filed quickly with the U.S. Copyright Office.',
    paragraph2: 'With affordable pricing and expert guidance, professional copyright protection is within reach for creators at every level. We\'ll help you secure the legal rights you need to control, monetize, and protect your creative works for generations to come.'
  };

  return (
    <ServiceTemplate
      title="Copyright Registration"
      subtitle="Protect Your Creative Works with Official Copyright Registration"
      description="Secure legal protection for your original works with U.S. Copyright Office registration. Our expert team handles the entire process, ensuring your creative works are fully protected."
      heroImage="https://images.unsplash.com/photo-1593444285553-28163240e3f1"
      aboutImage="https://images.unsplash.com/photo-1521791055366-0d553872125f?w=800"
      serviceId="copyright-registration"
      metaTitle="Copyright Registration for Creative Works | Trademark Vector"
      metaDescription="Register your books, music, software & artwork with the U.S. Copyright Office. Expert filing, proper classification & lifetime legal protection for creators."
      usps={usps}
      whyChooseContent={whyChooseContent}
    />
  );
};

export default CopyrightRegistration;
